import { render, staticRenderFns } from "./Nixtag.vue?vue&type=template&id=4d5d3935&scoped=true&"
import script from "./Nixtag.vue?vue&type=script&lang=js&"
export * from "./Nixtag.vue?vue&type=script&lang=js&"
import style0 from "./Nixtag.vue?vue&type=style&index=0&id=4d5d3935&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d3935",
  null
  
)

export default component.exports